import { render, staticRenderFns } from "./newrenzheng.vue?vue&type=template&id=ebcf2e3e&scoped=true&"
import script from "./newrenzheng.vue?vue&type=script&lang=js&"
export * from "./newrenzheng.vue?vue&type=script&lang=js&"
import style0 from "./newrenzheng.vue?vue&type=style&index=0&id=ebcf2e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcf2e3e",
  null
  
)

export default component.exports